<template>
  <div class="row advisor-search-page-zip no-gutters" role="tabpanel" id="advisor-search-by-location"
    aria-labelledby="advisor-search-page-tab_by_location">
    <div class="advisor-dropdown col-12 col-sm-12 col-md-5 col-lg-5" v-if="!isWealthAdvisorSearch"
      @click="showTypeFilter = !showTypeFilter">
      <button class="pill large" type="button" @click="showTypeDropdown = !showTypeDropdown" id="advisor-type"
        :aria-expanded="showTypeDropdown ? 'true' : 'false'" aria-controls="advisor-select">
        <span class="sr-only">Select</span>{{ typePlaceholder }}
        <span class="caret"></span>
      </button>
      <fieldset class="selection showselect" id='advisor-select' v-if="showTypeDropdown"
        v-click-outside="{ 'method': hideTypeDropdown, 'except': ['advisor-select', 'advisor-type'] }">
        <legend class="sr-only">
          Advisors Filter
        </legend>
        <div class="col-12 selection__radio" v-for="(filterOption) in typeFilterOptions" :key="filterOption">
          <input :id="filterOption" type="radio" name="advisor-type-select" v-model="type" v-bind:value="filterOption"
            @keyup.space="showTypeDropdown = false;" />
          <label :for="filterOption" @click="triggerAdvisorFilter(filterOption)"><span class="checkmark fas fa-check"
              aria-hidden="true"></span>{{ filterOption }}</label>
        </div>
      </fieldset>
    </div>
    <div
      v-bind:class="{ 'advisor-zip col-12': true, 'col-sm-12 col-md-10 col-lg-10': isWealthAdvisorSearch, 'col-sm-12 col-md-6 col-lg-6': !isWealthAdvisorSearch }">
      <div class="advisor-zip-wrap floating-label" v-bind:class="{ 'has-focus is-floating': focused }">
        <span class="pill large">
          <label class="search-location-label">{{ placeholder }}</label>
          <input 
            ref="place" 
            v-model="searchTerm"
            type="search" 
            @keyup.enter="onEnter"
            @focus="onFocus"
            @blur="onBlur"
            @input="onInput"
            @keydown.down="onArrowDown($event)"
            @keydown.up="onArrowUp($event)"
            @keydown.esc="closeDropdown"
            autocomplete="off"
            role="combobox"
            aria-autocomplete="list"
            :aria-expanded="showPredictions ? 'true' : 'false'"
            aria-controls="advisor-location-autocomplete-listbox"
            :aria-describedby="showError ? 'error-search-by-location' : 'advisors-search-by-location-autocomplete'"
            :aria-activedescendant="highlightedPrediction >= 0 ? `advisor-location-option-${highlightedPrediction}` : null"
            aria-label="Search" 
            class="pac-target-input" 
            placeholder="" 
          />
          
          <ul v-if="showPredictions && predictions && predictions.length" 
              class="autocomplete-dropdown"
              role="listbox"
              id="advisor-location-autocomplete-listbox">
            <li v-for="(prediction, idx) in predictions"
                :key="prediction.placePrediction.id"
                :id="`advisor-location-option-${idx}`"
                role="option"
                :aria-selected="idx === highlightedPrediction ? 'true' : 'false'"
                @mousedown.prevent="selectPrediction(idx)"
                :class="{ 'autocomplete-dropdown__option': true, 'highlighted': idx === highlightedPrediction }"
            >
              {{ prediction.placePrediction.text.text }}
            </li>
          </ul>
        </span>
        <p class="text-danger d-block d-lg-none" id="error-search-by-location" v-if="showError">{{
      text("advisorSearchByTypeError") }}</p>

        <div class="advisor-zip-text-wrap">
          <a href="javascript:;" v-on:click="nearMe(false)">{{ text("findMyLocation") }}</a>
        </div>
      </div>
      <p class="text-danger d-none d-lg-block" id="error-search-by-location" v-if="showError">{{
      text("advisorSearchByTypeError") }}</p>
      <p class="sr-only" id="advisors-search-by-location-autocomplete">Search results will populate as you type. Use the
        arrow keys to navigate and choose a result.</p>
    </div>
    <div class="location-submit-button col-12 col-sm-12 col-md-1 col-lg-1">
      <button class="btn btn-primary" @click="submitByClick">{{ text("advisorSearchByTypeCTA") }}</button>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { locText } from "../../../utils/useText";
import { capitalizeString } from "../../../utils/functions";
import parseAddress from '../functions/parseAddress';
import { Loader } from '@googlemaps/js-api-loader';
import { googleApi, mapConfigs } from "../../../config/map";

export default {
  data() {
    return {
      searchTerm: null,
      showError: false,
      showTypeFilter: false,
      type: null,
      showTypeDropdown: false,
      focused: false,
      current: false,
      directConsumer: false,
      presetTypeData: '',
      newStateArray: ['AR', 'KS', 'MO', 'OK', 'TN', 'TX', 'MS', 'Texas', 'Arkansas', 'Missouri', 'Kansas', 'Oklahoma', 'Tennessee', 'Mississippi'],
      selectedPlace: null,
      autocompleteRetryCount: 0,
      showPredictions: false,
      highlightedPrediction: -1,
      sessionToken: null
    };
  },
  created() {

    var uri = window.location.search.substring(1);
    var params = new URLSearchParams(uri);
    var initType = params.get("advisortype");
    this.presetTypeData = this.presetType
    if (initType) {
      this.type = this.userType = this.presetTypeData = initType;
    }
    this.getTypeFilterOptions();
    if (this.presetTypeData) {
      this.type = this.userType = this.presetTypeData;
    } 
  },
  mounted() {
    // Load Google Maps API for Places
    this.ensureGoogleMapsLoaded();

    // If local storage has zip, geolocate by zip
    // Else, trigger nearMe search by default (but suppress error if denied automatically)
    var zipCode = this.zipCodeFromLocalStorage;

    if (zipCode) {
      this.searchByZipCode(zipCode)
    } else {
      this.nearMe(true);
    }
  },
  computed: {
    isWealthAdvisorSearch() {
      return this.presetTypeData == "Wealth Advisor";
    },
    placeholder() {
      return  this.text("advisorsPlaceholder");
    },
    typeFilterOptions() {
      return this.$store.getters.typeFilterOptions;
    },
    typePlaceholder: {
      get() {
        return this.type
          ? capitalizeString(this.type)
          : this.text("advisorTypePlaceholder");
      }
    },
    userSearchLocation: {
      get() {
        return this.$store.getters.userSearchLocation;
      },
      set(value) {
        this.updateUserSearchLocation(value);
      }
    },
    newConsumerDirect: {
      get() {
        return this.$store.getters.newConsumerDirect;
      },
      set(value) {
        this.updateNewConsumerDirect(value);
      }
    },
    isDirectConsumer: {
      get() {
        return this.$store.getters.isDirectConsumer;
      },
      set(value) {
        this.updateDirectConsumer(value);
      }
    },
    userType: {
      get() {
        return this.$store.getters.userType;
      },
      set(value) {
        this.updateUserType(value);
      }
    },
    zipCodeFromLocalStorage: {
      get() {
        return window.localStorage.getItem('userZip');
      },
      set(value) {
        window.localStorage.setItem('userZip', value);
      }
    }
  },
  methods: {
    ...mapActions([
      "geolocateUser",
      "getTypeFilterOptions",
      "updateAdvisors",
      "updateUserSearchLocation",
      "updateUserType",
      "updateAdvisorsWithConsumer",
      "updateDirectConsumer",
      "updateNewConsumerDirect",
      "resetCurrentPage",
      "updateFilters"
    ]),
    async onInput() {
      this.current = this.searchTerm;
      this.showPredictions = false;
      this.highlightedPrediction = -1;
      
      if (!this.searchTerm || !window.google || !google.maps || !google.maps.places || !google.maps.places.AutocompleteSuggestion) {
        this.predictions = [];
        return;
      }
      
      if (!this.sessionToken) {
        this.sessionToken = new google.maps.places.AutocompleteSessionToken();
      }
      
      const locationRestriction = {
        west: mapConfigs.AutoCompleteBoundaries.west,
        north: mapConfigs.AutoCompleteBoundaries.north,
        east: mapConfigs.AutoCompleteBoundaries.east,
        south: mapConfigs.AutoCompleteBoundaries.south
      };
      
      const request = {
        input: this.searchTerm,
        sessionToken: this.sessionToken,
        locationRestriction,
        includedRegionCodes: mapConfigs.includedRegionCodes
      };
      
      try {
        const { suggestions } = await google.maps.places.AutocompleteSuggestion.fetchAutocompleteSuggestions(request);
        this.predictions = suggestions;
        this.showPredictions = true;
      } catch (err) {
        console.error('Error fetching predictions:', err);
        this.predictions = [];
        this.showPredictions = false;
      }
    },
    
    onArrowDown() {
      if (!this.showPredictions || !this.predictions.length) return;
      if (typeof this.highlightedPrediction !== 'number' || this.highlightedPrediction < 0 || this.highlightedPrediction >= this.predictions.length) {
        this.highlightedPrediction = 0;
      } else if (this.highlightedPrediction < this.predictions.length - 1) {
        this.highlightedPrediction++;
      } else {
        this.highlightedPrediction = 0;
      }
    },
    
    onArrowUp() {
      if (!this.showPredictions || !this.predictions.length) return;
      if (typeof this.highlightedPrediction !== 'number' || this.highlightedPrediction < 0 || this.highlightedPrediction >= this.predictions.length) {
        this.highlightedPrediction = this.predictions.length - 1;
      } else if (this.highlightedPrediction > 0) {
        this.highlightedPrediction--;
      } else {
        this.highlightedPrediction = this.predictions.length - 1;
      }
    },
    
    onEnter() {
      if (this.showPredictions && this.highlightedPrediction >= 0) {
        this.selectPrediction(this.highlightedPrediction);
      } else if (this.searchTerm) {
        this.selectPrediction(0);
        this.showPredictions = false;
        this.submitByEnter();
      }
    },
    
    onFocus() {
      this.focused = true;
    },
    
    onBlur() {
        this.showPredictions = false;
        this.highlightedPrediction = -1;
        this.focused = !!this.searchTerm;
    },
    
    closeDropdown() {
      this.showPredictions = false;
      this.highlightedPrediction = -1;
    },
    
    async selectPrediction(idx) {
      const prediction = this.predictions[idx];
      if (!prediction) return;
      
      this.showPredictions = false;
      this.searchTerm = prediction.placePrediction.text.text;
      this.current = this.searchTerm;
      
      const place = await prediction.placePrediction.toPlace();
      try {
        await place.fetchFields({ fields: ["displayName", "formattedAddress", "location", "addressComponents"] });
      } catch (e) {
        // fallback: do nothing, location may still be present
      }
      
      this.selectedPlace = {
        formatted_address: place.formattedAddress,
        addressComponents: place.addressComponents,
        geometry: {
          location: place.location
        }
      };
      
      this.sessionToken = null; // Reset session token after selection
      
      this.submitByEnter();
    },
    
    ensureGoogleMapsLoaded() {
      // If API is already loaded, return resolved promise
      if (typeof google !== 'undefined' && google.maps) {
        return Promise.resolve();
      }

      // If loader is already in progress, return existing promise
      if (window.googleMapsApiLoader) {
        return window.googleMapsApiLoader;
      }

      // Create new loader
      const loader = new Loader({
        apiKey: googleApi.mapKey || process.env.GOOGLE_API_KEY,
        version: "weekly",
        libraries: ["places"]
      });

      window.googleMapsApiLoader = loader.load().then(() => {
        return true;
      }).catch((error) => {
        console.error('Error loading Google Maps API:', error);
        throw error;
      });

      return window.googleMapsApiLoader;
    },
    async ensureGeocodingLoaded() {
      // If geocoding library is already loaded, return it
      if (window.googleGeocodingLibrary) {
        return window.googleGeocodingLibrary;
      }
      
      // Ensure main Google Maps API is loaded first
      await this.ensureGoogleMapsLoaded();
      
      // Import and cache the geocoding library
      const { Geocoder } = await google.maps.importLibrary("geocoding");
      window.googleGeocodingLibrary = { Geocoder };
      return window.googleGeocodingLibrary;
    },
    async nearMe(suppressError = false) {
      this.showError = false;
      this.userType = this.type;
      this.searchTerm = "";
      this.current = false;
      this.hideTypeDropdown();

      if (typeof HERO_analytics_data_layer != "undefined") {
        let analytics = HERO_analytics_data_layer,
          event = {
            event: "search",
            search__type: this.tabTitle,
            search__term: "Find by current location"
          };
        if (this.type) {
          event.search__advisor_type = this.type;
        }
        analytics.pushEventAndData(event);
      }

      navigator.geolocation.getCurrentPosition(
        async position => {
          try {
            // Ensure Google Maps API is loaded
            await this.ensureGoogleMapsLoaded();
            // Import the geocoding library
            const { Geocoder } = await this.ensureGeocodingLoaded();
            let latLng = {
              lat: position.coords.latitude,
              lng: position.coords.longitude
            };
            const geocoder = new Geocoder();
            geocoder.geocode({ 'location': latLng }, (results, status) => {
              if (status == google.maps.GeocoderStatus.OK) {
                let formattedAddress = results[0].formatted_address;
                this.checkStateForDirectConsumer(formattedAddress, latLng);
                this.showError = false;
                this.searchTerm = formattedAddress;
                this.current = true;
                this.focused = true;
                return results;
              } else {
                console.error("Geocoding request failed with status:", status);
                this.showError = true;
              }
            });
          } catch (error) {
            console.error('Failed to load Google Maps API for geocoding:', error);
            this.showError = true;
          }
        },
        error => {
          console.error(error.message);
          if (!suppressError) {
            this.showError = true;
          }
        }
      );
    },
    triggerAdvisorFilter(value) {
      this.showTypeDropdown = false;
      this.type = value;
      const payload = {
        type: this.type
      };

      this.updateFilters(payload);
    },
    hideTypeDropdown() {
      this.showTypeDropdown = false;
    },
    async searchByZipCode(zipCode) {
      this.userType = this.type;
      this.searchTerm = zipCode;
      this.current = true;
      this.focused = true;

      if (typeof HERO_analytics_data_layer != "undefined") {
        let analytics = HERO_analytics_data_layer,
          event = {
            event: "search",
            search__type: this.tabTitle,
            search__term: "Find by postal code"
          };
        if (this.type) {
          event.search__advisor_type = this.type;
        }
        analytics.pushEventAndData(event);
      }

      try {
        await this.ensureGoogleMapsLoaded();
        
        // Import the geocoding library
        const { Geocoder } = await this.ensureGeocodingLoaded();
        
        const geocoder = new Geocoder();
        geocoder.geocode({ 'address': 'zipcode ' + zipCode }, (results, status) => {
          this.loading = true;
          if (status == google.maps.GeocoderStatus.OK) {
            this.loading = false;
            var place = results[0];

            this.zipCodeFromLocalStorage = parseAddress(results, "postal_code");
            if (place && place.geometry && place.formatted_address) {
              let formattedAddress = place.formatted_address;
              if (typeof HERO_analytics_data_layer != "undefined") {
                let analytics = HERO_analytics_data_layer,
                  searchTerm = place.formatted_address,
                  event = {
                    event: "search",
                    search__type: this.tabTitle,
                    search__term: searchTerm
                  };
                if (this.type) {
                  event.search__advisor_type = this.type;
                }
                analytics.pushEventAndData(event);
              }
              const payload = {
                lat: place.geometry.location.lat(),
                lng: place.geometry.location.lng()
              };

              this.checkStateForDirectConsumer(formattedAddress, payload);
            } else {
              this.userSearchLocation = {};
              this.newConsumerDirect = [];
              this.showError = true;
            }
          } else {
            this.loading = false;
            this.showError = true;
          }
        });
      } catch (error) {
        console.error('Failed to load Google Maps API for geocoding:', error);
        this.showError = true;
      }
    },
    submitByClick() {
      this.showError = false;
      this.resetCurrentPage();
      this.hideTypeDropdown();

      if (this.searchTerm) {
        this.submitByEnter();
      } else if (
        this.userSearchLocation &&
        this.userSearchLocation.lat &&
        this.userSearchLocation.lng
      ) {
        this.nearMe();
      } else {
        this.showError = true;
        this.$refs.place.focus();
      }
    },
    submitByEnter() {
      this.resetCurrentPage();
      this.showError = false;
      this.hideTypeDropdown();

      this.userType = this.type;

      if (this.selectedPlace && this.selectedPlace.geometry && this.selectedPlace.formatted_address) {
        this.zipCodeFromLocalStorage = parseAddress([this.selectedPlace], "postal_code");
        let formattedAddress = this.selectedPlace.formatted_address;
        
        if (typeof HERO_analytics_data_layer != "undefined") {
          let analytics = HERO_analytics_data_layer,
            searchTerm = this.selectedPlace.formatted_address,
            event = {
              event: "search",
              search__type: this.tabTitle,
              search__term: searchTerm
            };
          if (this.type) {
            event.search__advisor_type = this.type;
          }
          analytics.pushEventAndData(event);
        }
        
        const payload = {
          lat: this.selectedPlace.geometry.location.lat(),
          lng: this.selectedPlace.geometry.location.lng()
        };

        this.checkStateForDirectConsumer(formattedAddress, payload);
      } else if (this.searchTerm) {
        this.searchByZipCode(this.searchTerm);
      } else {
        this.userSearchLocation = {};
        this.newConsumerDirect = [];
        this.showError = true;
      }
    },
    async checkStateArray(state, payload) {
      const stateArray = this.newStateArray;
      this.loading = true;
      if (stateArray.some(function (v) { return state.indexOf(v) >= 0; })) {
        this.isDirectConsumer = false;
        this.userSearchLocation = payload;
      } else {
        this.updateAdvisorsWithConsumer();
      }
    },
    async checkStateForDirectConsumer(formattedAddress, payload) {
      if (formattedAddress.indexOf(' ')) {
        var firstSplitArray = formattedAddress.split(', ');
      } else {
        var firstSplitArray = formattedAddress.split(',');
      }
      // check if any array item has a space in there will indicate there is a state.
      if (firstSplitArray.length > 2) {
        // checks for an abbreviated state with a space next to it?
        if (firstSplitArray[1].indexOf(' ') >= 0 || firstSplitArray[2].indexOf(' ') >= 0) {
          let state = firstSplitArray[1].split(' ')[0];
          let stateOneComma = firstSplitArray[2].split(' ')[0];

          // check if the state returned is 2 characters, if not, the address is longer and needs to be split in a diff spot 
          if (state.length !== 2) {

            // check if the returned stated matches the state array
            this.checkStateArray(stateOneComma, payload);
          } else {
            this.checkStateArray(state, payload);
          }
        } else {
          let stateNoZip = firstSplitArray[1];
          // if the formattedAddress does not have a zip code in it
          this.checkStateArray(stateNoZip, payload);
        }

      } else {
        let stateFull = firstSplitArray[0];
        this.checkStateArray(stateFull, payload);
      }
    }

  },
  mixins: [locText],
  props: {
    presetType: String,
    tabTitle: String
  },
  watch: {

    userSearchLocation(newValue) {
      let payload = {
        lat: newValue.lat,
        lng: newValue.lng,
        radius: this.$store.getters.userDistance
      };

      if (this.presetTypeData == "Wealth Advisor") {
        payload = {
          ...payload,
          wealth: true
        };
      }
      // call function to get new advisor data
      this.updateAdvisors(payload);
    }
  }
};
</script>
